export default __webpack_public_path__ + "static/media/gallery_00.486480e4.jpg";